module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/traffic-note-ce211aad8fc1733029745b33f3bf3784.svg&quot;;"